// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GnskHQcd8Q86S8 {
  display: flex;
  align-items: center;
  align-self: stretch;
  padding: var(--ds-space-200, 14px);
}
`, ""]);
// Exports
export var logoLink = `GnskHQcd8Q86S8`;
export default ___CSS_LOADER_EXPORT___;
